<template>
	<table class="table table-responsive table-hover admin-table">
		<thead>
			<tr>
				<th></th>
				<th>N°</th>
				<th>Título</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<tr class="clickable-row" v-for="item in list" id="{{ $index }}" v-drag-and-drop drop="handleDrop">
				<td>
					<i class="fa fa-bars"></i>
				</td>
				<td>{{ item.id }}</td>
				<td>{{ item.title }}</td>
				<td>
					<!-- <i class="fa fa-pencil" aria-hidden="true"></i> -->
					<i class="fa fa-trash" aria-hidden="true" @click="remove(item)"></i>
				</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
import { moveProject } from '../../store/actions';

export default {
	// ---- PROPS ----

	props: ['list', 'remove'],

	// ---- VUEX ----

	vuex: {
		getters: {
			user: state => state.current_user
		},
		actions: {
			moveProject
		}
	},

	// ---- METHODS ----

	methods: {
		handleDrop(old_item, new_item) {
			// get the from and to positions.
			let tmp = this.list[old_item.id];
			let id1 = this.list[old_item.id].id;

			this.list.splice(old_item.id, 1);
			this.list.splice(new_item.id, 0, tmp);
			this.moveProject(this.user, new_item.id, id1);
		}
	},
}
</script>


// WEBPACK FOOTER //
// Admin-projects-table.vue?4cda0ff0